module.exports = __webpack_public_path__ + "static/media/Scenery.950af024.png";